import { useMutation } from "@tanstack/vue-query"
import { v1 } from "@/axios"

/**
 * Submits an extend contact us request to customer care.
 */
export async function createExtendContactRequest(eventVaultId: number) {
  await v1.post(`/events/${eventVaultId}/extend/contact-us`)
}

const CREATE_EXTEND_CONTACT_REQUEST_KEY = "createExtendContactRequest"

export function useCreateExtendContactRequest() {
  return useMutation({
    mutationKey: [CREATE_EXTEND_CONTACT_REQUEST_KEY],
    mutationFn: (eventVaultId: number) => createExtendContactRequest(eventVaultId),
  })
}
